<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row :gutter="10" type="flex" justify="space-between" class="h-36px">
        <el-col :span="24" class="h-full flex">
          <el-input
            class="w-200px"
            size="small"
            :placeholder="$t('PleaseEnterAKeyword')"
            v-model.trim="keyword"
            clearable
          />
          <el-button class="ml-10px" type="primary" size="small" @click="searchList()">{{
            $t('search')
          }}</el-button>
          <el-button
            class="ml-10px"
            type="primary"
            size="small"
            @click="addLables('create')"
            :disabled="!$hasAccess('create')"
            >{{ $t('create') }}</el-button
          >
          <el-button class="ml-10px" type="danger" size="small" @click="delLabels('1')">{{
            $t('delete')
          }}</el-button>
          <el-button class="ml-10px" type="default" size="small" @click="exportFile()">{{
            $t('export')
          }}</el-button>
          <el-button class="ml-10px" type="default" size="small" @click="importFile()">{{
            $t('import')
          }}</el-button>
          <ColumnVisible
            :options="columnVisibleOptionsClass"
            :name="['classColumnVisible']"
            class="ml-10px"
            style="display: inline-block"
            :defaultValue="columnVisibleClass"
            @columnVisibleChanged="changeColumnClass"
          ></ColumnVisible>
        </el-col>
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        height="calc(100% - 104px)"
        class="mt-20px"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column :label="$t('seqNo')" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageInfo.pageNo - 1) * pageInfo.pageSize }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="代码" prop="code"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="创建人" prop="creatorName"></el-table-column>
        <el-table-column label="创建时间" prop="createdTime"></el-table-column>
        <el-table-column label="修改时间" prop="lastModifiedTime"></el-table-column> -->
        <el-table-column
          v-for="item in tableClassFilterHeader"
          :key="item.label"
          :label="`${$t(item.label)}`"
          :prop="item.value"
          :width="item.width"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column :label="$t('operate')">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('update')"
              size="mini"
              @click="addLables('update', scope.row)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('delete')"
              @click="delLabels('2', scope.row)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
      ></el-pagination>

      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        v-dialogDrag
        width="480px"
        @close="dialogClose"
      >
        <el-form label-width="80px" ref="form" :rules="formRules" :model="formData">
          <el-form-item :label="$t('labelCode')" prop="name" class="w-full">
            <el-input size="small" v-model.trim="formData.name" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('labelName')" prop="code" class="w-full">
            <el-input size="small" v-model.trim="formData.code" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('remarks')" prop="remark" class="w-full">
            <el-input
              size="small"
              type="textarea"
              v-model.trim="formData.remark"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer tc">
          <el-button type="primary" @click="formSave()" :loading="saveLoading">{{
            $t('save')
          }}</el-button>
          <el-button @click="dialogClose"> {{ $t('cancel') }} </el-button>
        </div>
      </el-dialog>
      <!-- 导入 -->
      <wiz-upload-file
        v-dialogDrag
        @refreshList="searchList"
        :uploadFileProps="uploadFileProps"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
      ></wiz-upload-file>
    </el-card>
  </div>
</template>

<script>
import ColumnVisible from '@/components/ColumnVisible'
import CommonService from '@/services/Common'
import stdClassLabelService from '@/services/stdClassLabelService'
import fnMixin from '@/assets/js/fnMixins'

export default {
  name: 'entityLabels',
  components: {
    ColumnVisible,
  },
  mixins: [fnMixin],
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      keyword: '',
      tableData: [],
      tableLoading: false,
      pageInfo: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      currentRow: null,
      selectionsIds: [],
      tableClassFilterHeader: [
        { value: 'code', label: this.$t('labelName') },
        { value: 'name', label: this.$t('labelCode') },
        { value: 'remark', label: this.$t('remarks') },
        { value: 'creatorName', label: this.$t('CreateUser') },
        { value: 'createdTime', label: this.$t('createTime') },
        { value: 'lastModifiedTime', label: this.$t('修改时间') },
      ],
      columnVisibleOptionsClass: [
        { value: 'code', label: this.$t('labelName') },
        { value: 'name', label: this.$t('labelCode') },
        { value: 'remark', label: this.$t('remarks') },
        { value: 'creatorName', label: this.$t('CreateUser') },
        { value: 'createdTime', label: this.$t('createTime') },
        { value: 'lastModifiedTime', label: this.$t('修改时间') },
      ],
      tableClassHeader: [
        { value: 'code', label: this.$t('labelName') },
        { value: 'name', label: this.$t('labelCode') },
        { value: 'remark', label: this.$t('remarks') },
        { value: 'creatorName', label: this.$t('CreateUser') },
        { value: 'createdTime', label: this.$t('createTime') },
        { value: 'lastModifiedTime', label: this.$t('修改时间') },
      ],
      columnVisibleClass: [
        'code',
        'name',
        'remark',
        'creatorName',
        'createdTime',
        'lastModifiedTime',
      ],
      dialogVisible: false,
      saveLoading: false,
      dialogTitle: '',
      formData: {
        name: '',
        code: '',
        remark: '',
      },
      formRules: {
        name: [{ required: true, message: this.$t('enterLabelName'), trigger: 'blur' }],
        code: [{ required: true, message: this.$t('enterLabelCode'), trigger: 'blur' }],
      },
    }
  },
  created() {
    this.searchList()
  },
  methods: {
    // 表格多选
    handleSelectionChange(selection) {
      this.selectionsIds = selection.map((item) => {
        return item.id
      })
    },
    // 新增标签
    addLables(val, row) {
      if (val === 'create') {
        this.dialogVisible = true
        this.dialogTitle = this.$t('create')
        this.formData = this.$options.data().formData
      } else if (val === 'update') {
        this.dialogVisible = true
        this.dialogTitle = this.$t('edit')
        this.currentRow = row
        this.getClassLabelDetail()
      }
    },
    // 获取列表数据
    async getClassLabelList() {
      this.tableLoading = true
      const res = await stdClassLabelService.getClassLabelList({
        filter: this.keyword,
        skipCount: this.pageInfo.pageSize * (this.pageInfo.pageNo - 1),
        maxResultCount: this.pageInfo.pageSize,
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.pageInfo.total = res.totalCount
        this.columnVisibleOptionsClass = this.tableClassHeader
        this.changeColumnClass(this.columnVisibleClass)
      }
    },
    // 搜索
    searchList() {
      this.tableData = []
      this.pageInfo.pageNo = 1
      this.getClassLabelList()
    },
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.searchTableData()
    },
    changeColumnClass(data) {
      if (data.length === 0 && this.tableClassFilterHeader.length === 1) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAtLeaseOneTableHeader'),
        })
        return
      }
      this.columnVisibleClass = data
      this.tableClassFilterHeader = _.filter(this.tableClassHeader, (item) => {
        return _.includes(data, item.value)
      })
      this.$nextTick(() => {
        if (this.$refs.classTable) {
          this.$refs.classTable.doLayout()
        }
      })
    },
    // 保存
    formSave() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.dialogTitle === this.$t('create')) {
            this.saveLoading = true
            const res = await stdClassLabelService.addClassLabel({
              ...this.formData,
            })
            this.saveLoading = false
            if (res && res.code === 0) {
              this.$message.success(this.$t('AddSuccess'))
              this.dialogVisible = false
              this.searchList()
            }
          } else {
            this.saveLoading = true
            const res = await stdClassLabelService.updateClassLabel({
              ...this.formData,
            })
            this.saveLoading = false
            if (res && res.code === 0) {
              this.$message.success(this.$t('editedSuccessfully'))
              this.dialogVisible = false
              this.searchList()
            }
          }
        }
      })
    },
    // 获取标签详情
    async getClassLabelDetail() {
      const res = await stdClassLabelService.getClassLabel(this.currentRow.id)
      if (res && res.code === 0) {
        this.formData = res.data
      }
    },
    // 删除
    async delLabels(type, row) {
      if (type === '1' && !this.selectionsIds.length) {
        this.$message.warning(this.$t('tickData'))
        return
      }
      if (type === '2') {
        this.selectionsIds = [row.id]
      }
      this.$confirm(this.$t('confirmDeleteLabel'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning',
      })
        .then(async () => {
          const res = await stdClassLabelService.removeClassLabel(this.selectionsIds)
          if (res && res.code === 0) {
            this.$message.success(this.$t('deleteSuccess'))
            this.searchList()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 关闭弹框
    dialogClose() {
      this.dialogVisible = false
    },
    // 导出
    async exportFile() {
      const res = await stdClassLabelService.exportFile({
        filter: this.keyword,
        downloadType: 0,
      })
      if (res) {
        this.downLoadBlob({
          name: '实体标签导出结果.xlsx',
          data: res,
        })
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: 'std/StdClassLabel/download-template',
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '实体标签导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await CommonService.uploadFile({
        reqUrl: 'std/StdClassLabel/import',
        reqData: formData,
      })
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '实体标签.xlsx',
          data: res,
        })
        this.searchList()
      }
      this.uploadFileProps.btnLoading = false
    },
  },
}
</script>

<style>

</style>
